import styled from 'styled-components';

export const GuiStyles = styled.div`
  position: relative;
  width: 100%;

  .innerGUI {
    position: relative;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    width: calc(100%);
    max-width: 840px;
  }

  .icon-button {
    position: relative;
    margin-right: 25px;
    width: 50px;
    height: 50px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slider-wrap {
    position: relative;
    margin-right: 20px;
    width: calc(100% - 60px);
    max-width: 780px;
  }

  .MuiSlider-thumb {
    transition: none !important;
  }
  .MuiSlider-track {
    transition: none !important;
  }
  .MuiSlider-rail {
    transition: none !important;
  }

  .slider-dates {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin-top: 6px;
    color: #666;
    font-weight: 500;
    margin-left: 75px;
    margin-right: 15px;
    margin-top: -18px;
  }
`;
